import {x0}                   from '../_helpers';
import LocomotiveScroll       from 'locomotive-scroll';
import { gsap }               from 'gsap/dist/gsap';
import { ScrambleTextPlugin } from 'gsap/dist/ScrambleTextPlugin';

gsap.registerPlugin(ScrambleTextPlugin);

const ScrollManager = (() => {

    let _scroll;

    const createScrollInstance = () => {
        _scroll = new LocomotiveScroll({
            el: x0('[data-scroll-container]'),
            smooth: true,
            touchMultiplier: 2,
            tablet: {
                smooth: true,
                direction: 'vertical',
                gestureDirection: 'vertical',
                breakpoint: 1024
            },
            smartphone: {
                smooth: true,
                direction: 'vertical',
                gestureDirection: 'vertical'
            }
        });

        _scroll.on('call', (value, way, obj) => {
            if (value === 'scrambleText') {
                if(way === 'enter') {
                    if (!obj.el.classList.contains('-animated')) {
                        gsap.to(obj.el, {
                            duration: 2,
                            scrambleText:{
                                text: obj.el.dataset.newtext,
                                chars: obj.el.dataset.newtext
                            }
                        });
                    }

                    obj.el.classList.add('-animated');
                }
            }
        });
    }

    const _init = () => {
        createScrollInstance();
    }

    const _stop = () => {
        _scroll && _scroll.stop();
    }

    const _update = () => {
        _scroll && _scroll.update();
    }

    const _start = () => {
        _scroll && _scroll.start();
    }

    const _scrollTo = (el) => {
        _scroll.scrollTo(el, {
            duration: 500
        });
    }

    return {
        init:  _init,
        stop:  _stop,
        update:  _update,
        scrollTo: _scrollTo,
        start: _start
    }

})();

export default ScrollManager;
